/* react-bits ports (vanilla):
   1. DotGrid (Backgrounds/DotGrid) -> hero canvas texture with cursor proximity glow.
   2. SplitText (TextAnimations/SplitText) -> char stagger on the decorative hero tagline.
   House rules kept: reduced-motion fully static, rAF paused on hidden tab,
   theme-owned reveal classes (pw-motion) never touched. */
(function () {
  if (window.__pwBits) return;
  window.__pwBits = true;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- DotGrid ---------- */
  function dotGrid() {
    var hero = document.querySelector('.pw-hero');
    if (!hero || hero.dataset.pwGrid) return;
    hero.dataset.pwGrid = '1';
    hero.style.position = hero.style.position || 'relative';

    var c = document.createElement('canvas');
    c.className = 'pw-dotgrid';
    c.setAttribute('aria-hidden', 'true');
    hero.appendChild(c);
    var ctx = c.getContext('2d');
    if (!ctx) return;

    var GAP = 26, SIZE = 2.2, PROX = 150;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, mx = -9999, my = -9999, raf = 0;

    function resize() {
      w = hero.offsetWidth; h = hero.offsetHeight;
      c.width = w * dpr; c.height = h * dpr;
      c.style.width = w + 'px'; c.style.height = h + 'px';
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      draw();
    }
    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var y = GAP / 2; y < h; y += GAP) {
        for (var x = GAP / 2; x < w; x += GAP) {
          var dx = x - mx, dy = y - my;
          var d = Math.sqrt(dx * dx + dy * dy);
          var t = d < PROX ? 1 - d / PROX : 0;
          t = t * t * (3 - 2 * t); /* smootherstep, same as source */
          var r = SIZE + t * 1.6;
          ctx.beginPath();
          ctx.fillStyle = 'rgba(184,149,106,' + (0.10 + t * 0.55).toFixed(3) + ')';
          ctx.arc(x, y, r, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }
    if (reduced) { resize(); window.addEventListener('resize', resize); return; }

    hero.addEventListener('pointermove', function (e) {
      var b = hero.getBoundingClientRect();
      mx = e.clientX - b.left; my = e.clientY - b.top;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; draw(); });
    });
    hero.addEventListener('pointerleave', function () {
      mx = my = -9999;
      if (!raf) raf = requestAnimationFrame(function () { raf = 0; draw(); });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && !raf) { raf = requestAnimationFrame(function () { raf = 0; draw(); }); }
    });
    window.addEventListener('resize', resize);
    resize();
  }

  /* ---------- SplitText (chars) ----------
     Target: numbered section headings. The hero tagline is owned by the sheen
     effect (background-clip:text), and transformed child spans break that paint
     path — chars are never inserted there. */
  function splitText() {
    var els = document.querySelectorAll('.pw-section-heading h2');
    Array.prototype.forEach.call(els, function (el) {
      if (el.dataset.pwSplitText) return;
      el.dataset.pwSplitText = '1';
      var text = (el.textContent || '').trim();
      if (!text) return;
      el.setAttribute('aria-label', text);
      el.textContent = '';
      var chars = [];
      text.split(/(\s+)/).forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { el.appendChild(document.createTextNode(' ')); return; }
        var w = document.createElement('span');
        w.className = 'pw-st-word';
        w.setAttribute('aria-hidden', 'true');
        part.split('').forEach(function (ch) {
          var s = document.createElement('span');
          s.className = 'pw-st-char';
          s.textContent = ch;
          w.appendChild(s);
          chars.push(s);
        });
        el.appendChild(w);
      });
      if (reduced) return;
      chars.forEach(function (s, i) {
        s.animate(
          [{ opacity: 0, transform: 'translateY(0.55em)' }, { opacity: 1, transform: 'none' }],
          { duration: 620, delay: i * 30, easing: 'cubic-bezier(0.22,1,0.36,1)', fill: 'backwards' }
        );
      });
    });
  }

  function boot() { dotGrid(); splitText(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
